import { useState } from 'react'
import { useRecordContext, useRefresh, useNotify, Form } from 'react-admin'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  Typography,
  TextField,
} from '@mui/material'
import { autoSaveField } from '../../../../Utils/AutoSave'
import { sendLog } from '../../../../Class/AuditLog'
import { usePriceModalContext } from '../../../../Utils/providers/PriceModalProvider'

const SalvageModal = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  const [chosenValue, setChosenValue] = useState(null)
  const [hasError, setHasError] = useState(false)

  const { activeModal, modalPayload, openModal, closeModal } =
    usePriceModalContext()

  if (!modalPayload?.maxPrice) return null

  const maxPrice = modalPayload.maxPrice
  const topScrapPrice = modalPayload?.topScrapPrice ?? 0

  const handleSubmit = async () => {
    if (hasError || chosenValue === null) return

    try {
      await saveChosenValue(chosenValue)
      sendLog('Customer accepted quote of ' + chosenValue)
      await saveOfferJourneyFollowed(true)
      closeModal()
      refresh()
    } catch (error) {
      notify('Error saving data', { type: 'error' })
    }
  }

  const handleDeclineOffer = async () => {
    if (hasError || chosenValue === null) return

    try {
      await saveChosenValue(chosenValue)
      sendLog(
        record.originId,
        'Customer declined initial quote of ' + chosenValue
      )
      closeModal()
      openModal('bestPrice', {
        topScrapPrice,
      })
    } catch (error) {
      notify('Error saving data', { type: 'error' })
    }
  }

  const saveOfferJourneyFollowed = async (value) => {
    await autoSaveField({
      fields: [
        {
          classToInitialize: null,
          method: 'setOfferJourneyFollowed',
          quoteRequestId: record['@id'],
          value: value,
        },
      ],
      iri: record.leadContact.vehicle.vehicleSalvage['@id'],
    })
  }

  const saveChosenValue = async (value) => {
    await autoSaveField({
      fields: [
        {
          classToInitialize: null,
          method: 'setChosenValue',
          quoteRequestId: record['@id'],
          value: value,
        },
      ],
      iri: record.leadContact.vehicle.vehicleSalvage['@id'],
    })
  }

  return (
    <Dialog
      disablebackdropclick="true"
      disableEnforceFocus
      hideBackdrop
      disableScrollLock
      fullWidth
      open={activeModal === 'salvage'}
      onClose={closeModal}
      aria-label="Get salvage price modal"
      sx={{
        left: '50%',
        top: '50%',
        right: 'initial',
        bottom: 'initial',
        transform: 'translate(-50%, -50%)',
        maxWidth: '768px',
        width: '100%',
      }}
      PaperProps={{
        sx: {
          padding: 2,
        },
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="h6" fontWeight={'bold'}>
                  Offer up to £{maxPrice}
                </Typography>
                <Typography>
                  Free collection from {record.leadContact.postcode}
                </Typography>
                <Typography>Deposit paid today</Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField
                autoComplete="off"
                error={hasError}
                helperText={`Must be between 0 and £${maxPrice}`}
                type="number"
                label="Offer Price"
                min={0}
                max={maxPrice}
                defaultValue=""
                onChange={(e) => {
                  const value =
                    e.target.value === '' ? null : Number(e.target.value)
                  setChosenValue(value)
                  setHasError(value === null || value < 0 || value > maxPrice)
                }}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          <DialogActions sx={{ padding: 0 }}>
            <Button label="ra.action.cancel" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              type="button"
              color="error"
              variant="contained"
              label="Decline offer"
              disabled={chosenValue === null || hasError}
              onClick={handleDeclineOffer}
            >
              Decline
            </Button>
            <Button
              type="button"
              variant="contained"
              label="Accept offer"
              disabled={chosenValue === null || hasError}
              onClick={handleSubmit}
            >
              Accept
            </Button>
          </DialogActions>
        </Form>
      </DialogContent>
    </Dialog>
  )
}

export default SalvageModal
